"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomePricingPoint = void 0;
const PricingPoint_1 = require("../entity/PricingPoint");
const createSomePricingPoint = ({ key = 'create', point = 100, rewardAmount = 10000, rewardCurrency = 'JPY', } = {}) => new PricingPoint_1.default({ key, point, rewardAmount, rewardCurrency });
exports.createSomePricingPoint = createSomePricingPoint;
